// extracted by mini-css-extract-plugin
var _1 = "PostHistoryView-module__animateUploadProgressBarWidth--giTE1";
var _2 = "PostHistoryView-module__animatedBackground--A5Fxx";
var _3 = "PostHistoryView-module__metaContainer--W63Dv";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "metaContainer" }
